import React from 'react'
import Box from '@mui/material/Box'
import { Button, DataGrid, PopUp } from '@ketch-com/deck'
import { useTogglePurposeEnabledStateModalUtils } from './hooks'
import { Typography } from '@mui/material'
import { togglePurposeEnabledStateTableColumnsListColumns } from './utils/togglePurposeEnabledStateDataGridUtils'

type Props = {
  purposeCode: string
  onSubmit?: () => void
  onCancel: () => void
}

export const TogglePurposeEnabledStateModal: React.FC<Props> = ({ purposeCode, onSubmit, onCancel }) => {
  const { purpose, isBusy, warnings, handleUpdatePurpose, isLoadingDependencies } =
    useTogglePurposeEnabledStateModalUtils({
      purposeCode,
      onSubmit,
      onCancel,
    })

  const hasWarnings = warnings.length > 0
  const onSubmitHandler = () => {
    handleUpdatePurpose({
      params: {
        purposeCode: purpose!.code,
        formData: {
          ...purpose,
          code: purpose!.code,
          enabled: !purpose?.enabled,
        },
      },
    })
  }

  return (
    <PopUp
      isLoading={isLoadingDependencies}
      title={purpose?.enabled ? 'Disable Purpose' : 'Enable Purpose'}
      popUpWidth={hasWarnings && purpose?.enabled ? '825px' : '550px'}
      onClose={(_: object, reason: string) => {
        if (reason === 'backdropClick') {
          return
        }
        onCancel()
      }}
      variant="dialog"
      popUpActionChildren={
        <>
          <Button color="secondary" size="large" onClick={onCancel} pending={isBusy}>
            Close
          </Button>
          <Button color="primary" size="large" onClick={onSubmitHandler} pending={isBusy}>
            Confirm
          </Button>
        </>
      }
    >
      {!isLoadingDependencies && (
        <Typography>
          Are you sure you want to {purpose?.enabled ? 'disable' : 'enable'}{' '}
          <Typography variant="label">{purpose?.name || purpose?.code}</Typography> purpose?
        </Typography>
      )}

      {purpose?.enabled && hasWarnings && (
        <>
          <Box display="flex" flexDirection="column" mb={2}>
            <Typography>
              The following Groups in Stacks contain only one selected purpose. <br /> Disabling{' '}
              <Typography variant="label">{purpose?.name || purpose?.code}</Typography> will disable these Groups or
              Stacks in Experiences:
            </Typography>
          </Box>
          <DataGrid
            sx={{
              paddingLeft: 0,
              paddingRight: 0,
            }}
            autosizeOnMount
            autosizeOptions={{
              includeHeaders: true,
              includeOutliers: false,
              columns: togglePurposeEnabledStateTableColumnsListColumns.map((column, index) => column.field),
              expand: true,
            }}
            getRowHeight={() => 'auto'}
            columns={togglePurposeEnabledStateTableColumnsListColumns}
            disableChildrenSorting
            disableColumnMenu
            disableColumnPinning
            disableColumnResize
            disableColumnReorder
            getRowId={row => row[0]}
            rows={warnings}
            hideFooter
          />
        </>
      )}
    </PopUp>
  )
}
